
//export const base_url = 'http://localhost:3000/'; 
export const base_url = 'http://estauae.integratesolu.com/'; 
//export const base_url = 'https://ccme.ae/'; 
export const api_base_url = 'http://estauaeadmin.integratesolu.com/public/api/'; 
//export const api_base_url = 'https://ccme.ae/admin/public/api/'; 
 